import React, { useEffect, useState } from 'react';
import tableOfContent from '../../../utils/constants/tableOfContent';
import { SideMenu, Loader } from '../../common';
import { Icon } from '@mobilearch/react-ui';
import { Wrapper } from './styles';
import { TableOfContent } from '../../../typings/interfaces';

const Home = (): React.ReactElement => {
  // TOGGLE NAVBAR
  const [showMenu, setShowMenu] = useState(false);
  // SELECT LANGUAGE
  const [translation, setTranslation] = useState<TableOfContent>(
    tableOfContent.find((content) => content.language === 'en') || tableOfContent[0],
  );

  useEffect(() => {
    const languageAbv =
      window.navigator.language.indexOf('-') > -1
        ? window.navigator.language.slice(0, window.navigator.language.indexOf('-'))
        : window.navigator.language;
    const foundLanguage = tableOfContent.find((content) => content.language === languageAbv);
    if (foundLanguage) {
      setTranslation(foundLanguage);
    }
  }, []);

  const handleNumberPage = (pageNumber: number) => {
    const foundElement = document.getElementById(`page${pageNumber}`);
    if (foundElement) {
      foundElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
    setShowMenu(false);
  };

  const handleTranslation = (language: string) => {
    const foundTranslation = tableOfContent.find((content) => content.language === language);
    if (foundTranslation) {
      setTranslation(foundTranslation);
      setShowMenu(false);
    }
  };

  return (
    <Wrapper className="page-container">
      <header className="page-header">
        <Icon onClick={() => setShowMenu(!showMenu)}>{showMenu ? 'close' : 'menu'}</Icon>
        {translation && (
          <a className="download" target="_blank" href={translation.pdfLink} download rel="noreferrer">
            <Icon>get_app</Icon>
          </a>
        )}
      </header>
      <div className="page-content">
        <aside id="aside" className="aside" aria-expanded={showMenu}>
          {translation && (
            <SideMenu
              handleNumberPage={handleNumberPage}
              handleTranslation={handleTranslation}
              translation={translation}
              active={showMenu}
            />
          )}
        </aside>
        <main className="main">
          <div className="content-container">
            {translation ? (
              translation.source.map(
                (image, index) => index != 1 && <img src={image} id={`page${index}`} key={`page${index + 1}`} />,
              )
            ) : (
              <Loader />
            )}
          </div>
        </main>
      </div>
    </Wrapper>
  );
};

export default Home;
